export const SORT_OPTIONS = [
  {
    label: 'Most Recent',
    value: 'dateASC',
  },
  {
    label: 'Oldest First',
    value: 'dateDESC',
  },
  {
    label: 'Lowest Price',
    value: 'priceASC',
  },
  {
    label: 'Highest Price',
    value: 'priceDESC',
  },
  {
    label: 'Title (A-Z)',
    value: 'titleASC',
  },
  {
    label: 'Title (Z-A)',
    value: 'titleDESC',
  },
];
